<script>
  import { format } from 'svelte-i18n';
  import { Button, Modal, ModalBody, ModalFooter } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { deepCopy } from '@common/utils/objects';

  import { GroupFormContent } from '../shared';

  export let route = {};
  export let show = false;
  export let groups = [];
  export let tags = [];
  export let campaigns = [];
  export let onUpdate = () => {};

  let originalRoute = deepCopy(route);

  let types = [
    {
      label: $format('label.RECIPIENT'),
      value: 'recip'
    },
    {
      label: $format('label.SENDER'),
      value: 'sender'
    }
  ];

  const onCancelHandler = () => {
    route = deepCopy(originalRoute);
    show = false;
  };

  const onUpdateHandler = () => onUpdate(route);
</script>

<Modal bind:isOpen={show} size="md" fullscreen="sm" aria-labelledby="modal-title" role="dialog">
  <ModalBody class="targeting-groups-modal">
    <button class="close" on:click={() => (show = !show)} aria-label="Close modal" tabindex="0">
      <Icon name="x" aria-hidden="true" />
    </button>
    <div class="heading">
      <h1 id="modal-title">
        {#if route._id}
          {$format('label.EDIT_GROUP_TARGET')}
        {:else}
          {$format('label.CREATE_GROUP_TARGET')}
        {/if}
      </h1>
    </div>

    <GroupFormContent bind:route {types} {groups} {campaigns} {tags} />
  </ModalBody>
  <ModalFooter class="border-top p-4 mt-2">
    <Button color="link" on:click={onCancelHandler}>
      {$format('label.CANCEL')}
    </Button>
    <Button color="primary" on:click={onUpdateHandler}>
      {$format('label.UPDATE')}
    </Button>
  </ModalFooter>
</Modal>

<style lang="scss" src="./edit.scss"></style>
